import FONDO from "../assets/inicio.jpg";

const SectionOne = () => {
  return (
    <div className="w-full h-screen flex flex-col md:flex-row">
      <div className="w-full md:w-1/2 flex justify-center items-center">
        <img
          src={FONDO}
          alt="Inicio"
          className="h-full w-auto object-contain"
        />
      </div>
      <div className="w-full md:w-1/2 flex flex-col justify-center p-8 md:p-16 bg-red-700">
        <h1 className="text-3xl md:text-5xl font-bold text-white">
          ALIADOS EN CONSULTORÍA DE EMPRESAS
        </h1>
        <p className="mt-6 text-gray-200 text-base md:text-lg">
          Somos una firma dedicada a la asesoría y consultoría empresarial para las áreas estratégicas de su negocio.
        </p>
      </div>
    </div>
  );
};

export default SectionOne;
